<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        For a first-order reaction, if
        <number-value :value="percentage" unit="\%" />
        of the sample has decomposed after
        <number-value :value="reactionTime" unit="\text{s,}" />
        what is the half-life of the reaction?
      </p>

      <calculation-input
        v-model="inputs.halfLife"
        prepend-text="$\text{t}_{1/2}:$"
        append-text="$\text{s}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question95',
  components: {
    StembleLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        halfLife: null,
      },
    };
  },
  computed: {
    reactionTime() {
      return this.taskState.getValueBySymbol('reactionTime').content;
    },
    percentage() {
      return this.taskState.getValueBySymbol('percentage').content;
    },
  },
};
</script>
